/**
 * @param {Function} fn 防抖函数
 * @param {Number} delay 延迟时间
 */
import { Message } from 'element-ui';
export default {
  handleChartLoop(option, myChart) {
    if (!myChart) {
      return;
    }
    let currentIndex = -1; // 当前高亮图形在饼图数据中的下标
    this.timeTicket = setInterval(selectPie, 3000); // 设置自动切换高亮图形的定时器

    // 取消所有高亮并高亮当前图形
    function highlightPie() {
      // 遍历饼图数据，取消所有图形的高亮效果
      for (var idx in option.series[0].data) {
        myChart.dispatchAction({
          type: "downplay",
          seriesIndex: 0,
          dataIndex: idx,
        });
      }
      // 高亮当前图形
      myChart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: currentIndex,
      });
    }
    // 用户鼠标悬浮到某一图形时，停止自动切换并高亮鼠标悬浮的图形
    myChart.on("mouseover", (params) => {
      clearInterval(this.timeTicket);
      currentIndex = params.dataIndex;
      highlightPie();
    });
    // 用户鼠标移出时，重新开始自动切换
    myChart.on("mouseout", (params) => {
      if (this.timeTicket) {
        clearInterval(this.timeTicket);
      }
      this.timeTicket = setInterval(selectPie, 1000);
    });

    // 高亮效果切换到下一个图形
    function selectPie() {
      var dataLen = option.series[0].data.length;
      currentIndex = (currentIndex + 1) % dataLen;
      highlightPie();
    }
  },
  getLocalCity() {
    var data = {
      key: 'AK7BZ-6GH6N-BNSF6-S2D4J-6SP5H-Q5BT2'
    }
    var url = 'https://apis.map.qq.com/ws/location/v1/ip' //这个就是地理位置信息的接口
    data.output = 'jsonp'
    this.$jsonp(url, data)
      .then((res) => {
        console.log(res)
        // 根据城市，获取当前天气和时间（在此先预留获取天气方法，完成后取消注释）
        // this.getLocalWeather(this.location)  // 这里就是调用下面的那个
        return res
      })
      .catch((error) => {
        console.log(error)
      })
  },
  getLocalWeather(location) {
    this.$axios
      .get(
        `https://devapi.qweather.com/v7/weather/now?location=${location.lng},${location.lat}&key=09f6b56eb02b4daa8ddcd7742c460d34`
      )
      .then((res) => {
        console.log(res);
        // this.local.temperature = res.data.now.temp;
        // console.log(this.local.temperature);
        return res.data.now;
      });
  },
  formatTime(time, fmt) {
    if (!time) return '';
    else {
      const date = new Date(time);
      const o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'H+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        S: date.getMilliseconds(),
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        );
      for (const k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          );
        }
      }
      return fmt;
    }
  },
  suc(data) {
    Message({
      message: data,
      type: 'success'
    });
  },
  error(err) {
    Message({
      message: err,
      type: 'error'
    });
  },
}
export function debounce(fn, delay) {
  var timer;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * @param {date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time, fmt) {
  if (!time) return '';
  else {
    const date = new Date(time);
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        );
      }
    }
    return fmt;
  }
}




// WEBPACK FOOTER //
// ./src/utils/index.js